import Patient from './Patient'

export default class PatientCollection extends Array {

	constructor (data) {
		super()
		data.forEach(element => {
			this.push(new Patient(element))
		})
	}
}



// WEBPACK FOOTER //
// ./src/classes/PatientCollection.js